import HoolahLandingPage from './HoolahLandingPage'

export default HoolahLandingPage
